export const sendOptions = [
  {
    value: 0,
    label: "Tümü",
  },
  {
    value: 1,
    label: "SMS",
  },
  {
    value: 2,
    label: "E-Mail",
  },
  {
    value: 3,
    label: "E-Mail + SMS"
  },
  {
    value: 4,
    label: "Link Oluştur"
  },
  {
    value: 5,
    label: "Whatsapp",
  },
];
export const getSendOptions=()=>{

  

}


export const getSendOptionsDesc = (id) => {

  var index = sendOptions.findIndex(w => w.value == id);
  return sendOptions[index].label;
}
export const getSendOptionById = (id) => {
  var index = sendOptions.findIndex(w => w.value == id);
  return sendOptions[index];
}

export const sendTypeIds = {
  all: 0,
  sms: 1,
  email: 2,
  emailAndSms: 3,
  whatsapp: 5,
  link : 4,
  qr: 6
}